import PageBuilder from '@commons/pagebuilder';
import type { DrupalBlock, DrupalTerm } from '@commons/types/drupal';

// Type definition for the TermBlock component properties.

type Props = DrupalBlock<DrupalTerm>;

/**
 * Term block component.
 */

const TermBlock = ({ content }: Props) => {
  return PageBuilder.renderTerm(content);
};

export default TermBlock;
